import { useQuery } from "@tanstack/react-query"
import { getFaQ } from "../../transactions/faq/faq"
import { Accordion, AccordionItem, AccordionContent, AccordionTrigger } from "../../components/ui/Accordion"
import { useEffect, useState } from "react"
import { useToast } from "../../components/ui/Toast/useToast"
import { useNavigate } from "react-router-dom"
import { LeftArrow } from "../../icons"

export const FaqPage = () => {
    const [questions, setQuestions] = useState([]);

    const { toast } = useToast();
    const navigate = useNavigate();

    const {  isError, error } = useQuery({
        queryKey: ['faq'],
        queryFn: getFaQ,
        onSuccess: (data) => {
            const uniqueItems = Array.from(new Set(data.data.data.map(item => item.question)))
                .map(question => {
                return data.data.data.find(item => item.question === question);
                });
            setQuestions(uniqueItems);  
        }
    })
    
    useEffect(() => {
        if (isError) {
            toast({
                variant: 'destructive',
                description: error,
              });
        }
    },[isError,error])

    return(
        <div className="container mx-auto" style={{ height: 'calc(100vh - 140px)' }}>
            <div className="pt-10 flex flex-col gap-10">
                <div className="flex max-lg:gap-2 items-center max-lg:hidden">
                    <button className='p-2' onClick={() => navigate('/dashboard')}>
                        <LeftArrow width={24} height={24} />
                    </button>
                <h2 className="max-lg:hidden">Κέντρο Υποστήριξης</h2>
                </div>
                <div className="flex max-lg:flex-col-reverse gap-5 justify-center">
                    <div className="bg-white flex-col rounded-[20px] p-6 flex gap-5 mb-10 lg:w-[60vw]">
                        <h3>FAQ</h3>
                        <Accordion className="w-full" type="single" collapsible>
                            {questions.map((item,index)=> 
                                <AccordionItem value={item.question} key={index}>
                                <AccordionTrigger  className={'ml-5'}>{item.question}</AccordionTrigger>
                                <AccordionContent className={'ml-5 w-10/12'}>
                                {item.answer}
                                </AccordionContent>
                            </AccordionItem>
                            )}
                        </Accordion>
                    </div>
                    <div className="bg-white flex-col rounded-[20px] p-6 flex gap-5 h-fit lg:w-[20vw]">
                        <h3>Eπικοινωνία</h3>
                        <div className="flex  flex-col gap-2">
                            <p>Εξυπηρέτηση Πελατών</p>
                            <p>+302106879800</p>
                            <p>Service</p>
                            <p>+302106879800</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}